import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const res = await api.createSession(session_id);
        setUser(res.user);
        // clean the hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: res.user } });
      } catch (e) {
        setError(e.data?.detail || "Authentication failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="wrap" style={{ padding: "80px 0", textAlign: "center", color: "var(--white-soft)" }}>
      {error ? <p style={{ color: "var(--coral)" }}>{error}</p> : <p>Signing you in…</p>}
    </div>
  );
}
